<div [class.left]="alignLeft" [matTooltip]="tooltip" [matTooltipDisabled]="!hasTooltip">
  <button
    [attr.type]="type"
    class="{{ color }}"
    [class.dense]="dense"
    [matButton]="matButtonType"
    [routerLink]="buttonLink"
    (click)="action.emit()"
    [disabled]="disabled"
  >
    @if (icon) {
      <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
    }

    <ng-content></ng-content>

    @if (iconRight) {
      <mat-icon class="material-icons-outlined" iconPositionEnd>{{ iconRight }}</mat-icon>
    }
  </button>
</div>
